import type { PropsWithChildren } from "react";

import styles from "./ContactDetails.module.scss";

export type ContactDetailsProps = {
  title: string;
  subTitle?: string;
  text?: string;
};

export const ContactDetails = ({ title, subTitle, text, children }: PropsWithChildren<ContactDetailsProps>) => (
  <div className={styles.contactDetails}>
    <div className={styles.contactDetailsContent}>
      <div className={styles.contactDetailsTitle}>{title}</div>
      <div className={styles.bottom}>
        <div className={styles.contactDetailsContainer}>
          {subTitle && <div className={styles.contactDetailsSubTitle}>{subTitle}</div>}
          {text && <div className={styles.contactDetailsText}>{text}</div>}
        </div>
        <div className={styles.contactDetailsInfoBlocks}>{children}</div>
      </div>
    </div>
  </div>
);
